module.exports = __webpack_public_path__ + "static/media/netcents-white.ab33b21a.png";